import PropTypes from 'prop-types';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import React, { useState } from 'react';

import AppsTab from './apps';
import ApiKeysTab from './apiKeys';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && children}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Integrations = () => {
    const [valueLeftTab, setValueLeftTab] = useState(0);

    const handleTabsSetLeft = (event, newValueLeftTab) => {
        setValueLeftTab(newValueLeftTab);
    };

    return (

        <div className='content account-tabs'>
            <div className='settings-card' style={{ padding: 0, overflow: 'hidden' }}>
                <div className='account-tab-inner' style={{ display: 'block' }}>
                    <div className='tabs-box'>
                        <div className='tabs-email tabs-setting-main'>
                            <AppBar position='static'>
                                <Tabs value={valueLeftTab} onChange={handleTabsSetLeft}>
                                    <Tab label="Apps" {...a11yProps(0)} />
                                    <Tab label="API Keys" {...a11yProps(1)} />
                                    {/* <Tab label="Webhooks" {...a11yProps(2)} /> */}
                                </Tabs>
                            </AppBar>
                        </div>
                    </div>
                    <div className='tabs-content'>
                        <TabPanel value={valueLeftTab} index={0}>
                            <AppsTab />
                        </TabPanel>
                        <TabPanel value={valueLeftTab} index={1}>
                            <ApiKeysTab />
                        </TabPanel>
                        {/* <TabPanel value={valueLeftTab} index={2}>
                            <WebhooksTab />
                        </TabPanel> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Integrations;

